<div class="p-2 container-xxl user-detail-page">
  <div class="w-100 mb-2">
    <app-nav-prev-button (click)="onBack()"></app-nav-prev-button>
    <div class="text-color default-page-headline pt-2">
      <ng-container *ngIf="selectedUser$ | async as user">
        <h3>
          {{ 'monitoring.users.monitored_user_data' | translate }} - {{ user.firstName }}
          {{ user.lastName }}
        </h3>
      </ng-container>
    </div>
  </div>

  <tabset>
    <tab heading="{{ 'monitoring.users.monitored_user_data' | translate }}" [active]="true">
      <ng-container *ngIf="selectedUser$ | async as user">
        <app-monitored-user-details [monitoredUser]="user"></app-monitored-user-details>
      </ng-container>
    </tab>

    <tab heading="{{ 'monitoring.users.monitored_user_evaluation' | translate }}">
      <ng-container *ngIf="selectedUser$ | async as user">
        <app-monitored-user-analysis [user]="user"></app-monitored-user-analysis>
      </ng-container>
    </tab>

    <tab heading="{{ 'monitoring.users.monitored_user_surveys' | translate }}">
      <app-monitored-user-submissions-list></app-monitored-user-submissions-list>
    </tab>

    <tab heading="{{ 'monitoring.users.monitored_user_flow' | translate }}">
      <ng-container *ngIf="selectedUser$ | async as user">
        <app-monitored-user-flow [monitoredUser]="user"></app-monitored-user-flow>
      </ng-container>
    </tab>

    <tab heading="{{ 'monitoring.users.monitored_user_diary' | translate }}">
      <ng-container *ngIf="selectedUser$ | async as user">
        <div class="card px-2 py-1 mb-2 mt-1 flow-card">
          <app-nutrition-diary-list [userId]="user.id"></app-nutrition-diary-list>
        </div>
      </ng-container>
    </tab>
  </tabset>
</div>
